import Loadable from 'react-loadable';
import LoadingPage from '../../fetching/LoadingPage';

export const LazyLoadedSettingsRoute = Loadable<Record<string, unknown>, any>({
  loader: async () =>
    import(/* webpackChunkName: "settings-route" */ './SettingsRoute').then((module) => module.SettingsRoute),
  loading: LoadingPage,
});
